

import React from "react";
import { faMagic } from "@fortawesome/free-solid-svg-icons/faMagic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


function MeleeIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="svg-inline--fa fa-dove fa-w-16 fa-s"
            viewBox="0 0 290.226 290.226">
            <g>
            <path d="M63.951,243.575c-1.945-3.578-4.401-6.907-7.363-9.869c-3.106-3.102-6.626-5.633-10.4-7.63
                c-4.51-2.387-0.945-7.5-0.945-7.5c4.616-7.023,8.825-14.079,12.305-20.226l-23.363-23.344H11.504c-4.362,0-7.898-3.539-7.898-7.902
                c0-4.361,3.536-7.9,7.898-7.9h25.947c2.1,0,4.107,0.832,5.588,2.312l85.379,85.291c1.483,1.483,2.315,3.495,2.315,5.589v26.073
                c0,4.365-3.537,7.897-7.9,7.897c-4.367,0-7.904-3.531-7.904-7.897v-22.798l-23.27-23.24c-6.281,3.707-13.582,8.252-20.816,13.25
                C70.842,245.679,66.698,248.629,63.951,243.575z"/>
            <path d="M26.61,237.102c-7.106,0-13.784,2.764-18.812,7.784c-5.019,5.015-7.782,11.686-7.782,18.778
                c0,7.097,2.764,13.762,7.782,18.776c5.027,5.016,11.706,7.783,18.812,7.785c7.102,0,13.781-2.77,18.804-7.785
                c5.023-5.015,7.79-11.682,7.79-18.776c0-7.093-2.768-13.764-7.79-18.778C40.392,239.866,33.712,237.102,26.61,237.102z"/>
            <path d="M100.985,182.318c-3.502,3.499-9.232,3.499-12.734,0.001l-8.81-8.801c-3.502-3.498-3.502-9.223,0-12.721L229.832,10.564
                c3.502-3.498,10.401-6.727,15.33-7.175l36.862-3.352c4.93-0.448,8.596,3.218,8.148,8.148l-3.346,36.791
                c-0.448,4.93-3.68,11.825-7.182,15.324l-150.4,150.251c-3.502,3.498-9.232,3.498-12.734,0l-8.822-8.813
                c-3.502-3.498-3.502-9.223,0-12.722L233.608,63.213c1.854-1.848,1.856-4.852,0.003-6.702c-1.848-1.853-4.853-1.853-6.709-0.002
                L100.985,182.318z"/>
            </g>
        </svg>
    );
}
  
function RangedIcon() {
return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-inline--fa fa-dove fa-w-16 fa-s"
    viewBox="0 0 512 512"
    >
    <path d="M492.656 20.406l-118.594 56.22L413.875 86l-86.97 86.97-305.5 259.374.69.687 104.75-47.467-46.376 105.843.905.906 272.5-319.875 73.22-73.218 9.342 39.81 56.22-118.624zm-473.25.063c-1.347 23.43 5 39.947 16.563 52.218l24.093 302.28 17.562-14.874-21.72-272.438C113.879 119.609 225 112.82 272.811 194.375l66.625-56.564 1.22-1.218C292.74 38.666 86.01 99.716 19.406 20.47zm359.531 151.56l-1.156 1.157-57.25 67.188c82.006 47.945 75.587 159.267 107.283 218.03l-272.157-24.5-14.812 17.408 301.562 27.125c12.48 12.283 29.4 19.084 53.688 17.687-79.95-67.2-18.36-275.754-117.156-324.094z"></path>
    </svg>
);
}

function SpecialIcon() {
return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-inline--fa fa-dove fa-w-16 fa-s"
    viewBox="0 0 512 512"
    >
    <path
      d="M256.04 273.772a38.2 38.2 0 0 0 19.016-5.109c18.156-10.5 24.406-33.828 13.922-52.031-6.781-11.75-19.438-19.031-33.016-19.031a38.1 38.1 0 0 0-19.016 5.109c-18.172 10.516-24.438 33.828-13.922 52.031 6.781 11.734 19.437 19.031 33.016 19.031M296.633 306.084c-3.625-6.297-11.328-8.891-18.031-6.109 0 0 1.031.391-4.734 1.969a68.4 68.4 0 0 1-17.875 2.375 68.4 68.4 0 0 1-17.875-2.375c-5.766-1.578-4.719-1.969-4.719-1.969-6.703-2.781-14.438-.188-18.031 6.109l-80.156 138.812a14.44 14.44 0 0 0-1.313 11.438 14.5 14.5 0 0 0 7.516 8.75s7.219 4.438 18.297 8.891c30.484 12.297 63.234 18.703 96.281 18.766a259.1 259.1 0 0 0 96.297-18.766c11.078-4.453 18.297-8.891 18.297-8.891 3.594-1.766 6.328-4.922 7.5-8.75s.688-7.969-1.297-11.438zM510.508 199.928a258.8 258.8 0 0 0-31.906-92.781c-16.547-28.609-38.469-53.719-64.375-74.016-9.422-7.344-16.875-11.391-16.875-11.391-3.281-2.25-7.391-3.016-11.328-2.109a14.44 14.44 0 0 0-9.266 6.844l-80.125 138.813c-3.625 6.266-2.016 14.266 3.734 18.672 0 0-.188-1.109 4.078 3.109a70.5 70.5 0 0 1 11 14.281 69.8 69.8 0 0 1 6.859 16.672c1.531 5.797.672 5.078.672 5.078.938 7.203 7.031 12.594 14.313 12.594H497.57a14.444 14.444 0 0 0 14.391-15.468c0-.001.234-8.485-1.453-20.298M189.024 223.1s-.859.719.672-5.078a68.5 68.5 0 0 1 6.859-16.672c3.063-5.281 6.766-10.063 11-14.281s4.063-3.109 4.063-3.109c5.766-4.406 7.375-12.406 3.75-18.672L135.211 26.475a14.4 14.4 0 0 0-9.266-6.844 14.38 14.38 0 0 0-11.328 2.109s-7.453 4.047-16.844 11.391c-25.906 20.297-47.828 45.406-64.406 74.016a259.7 259.7 0 0 0-31.906 92.781C-.195 211.741.039 220.225.039 220.225c-.281 3.984 1.063 7.922 3.828 10.859a14.39 14.39 0 0 0 10.563 4.609h160.281c7.266.001 13.375-5.39 14.313-12.593"
      className="st0"
    ></path>
    </svg>
);
}


function NoneIcon() {
return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    className="svg-inline--fa fa-dove fa-w-16 fa-s"
    viewBox="0 0 1920 1920"
    >
    <path
    fillRule="evenodd"
    d="M213.333 960c0-167.36 56-321.707 149.44-446.4L1406.4 1557.227c-124.693 93.44-279.04 149.44-446.4 149.44-411.627 0-746.667-335.04-746.667-746.667m1493.334 0c0 167.36-56 321.707-149.44 446.4L513.6 362.773c124.693-93.44 279.04-149.44 446.4-149.44 411.627 0 746.667 335.04 746.667 746.667M960 0C429.76 0 0 429.76 0 960s429.76 960 960 960 960-429.76 960-960S1490.24 0 960 0"
    ></path>
    </svg>

    // <svg width="512px" height="512px" 
    // className="svg-inline--fa fa-dove fa-w-16 fa-s" 
    // viewBox="-4 0 512 512" 
    // xmlns="http://www.w3.org/2000/svg">
    //     <path d="M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"/>
    // </svg>
);
}


export const attackTypesMapping = {
    Melee: <MeleeIcon/>,
    Ranged: <RangedIcon/>,
    Special: <SpecialIcon/>,
    Spell: <FontAwesomeIcon icon={faMagic} />,
    None: <NoneIcon/>,
};
